import cn from 'classnames'

import ButtonOrange from 'components/ui/button/_color/_orange'

import scrollToElement from 'utils/scroll-to-element'

import { useCallback } from 'react'

import { useTranslation } from 'utils/use-translation'

import styles from './styles.module.scss'

import IconGear from './icon-gear.svg'
import IconHeadphones from './icon-headphones.svg'
import IconCoins from './icon-coins.svg'

export default function MainBlock() {
  const { t } = useTranslation()

  const handleScrollToForm = useCallback(() => {
    scrollToElement('contactForm')
  }, [])
  return (
    <div className={cn('container', styles.mainBlock)}>
      <h1 className={styles.mainBlockTitle}>{t('enhance_crypto_business')}</h1>
      <div className={styles.mainBlockText}>{t('expand_customer_offering')}</div>
      <ButtonOrange onClick={handleScrollToForm}>{t('contact_us_capital')}</ButtonOrange>
      <div className={styles.mainBlockSubtitle}>{t('business_approach')}</div>
      <div className={styles.iconsBlock}>
        <div>
          <img src={IconGear} alt="IconGear" width={112} height={112} />
          <p className={styles.iconHeading}>
            {t('fully')}
            <br />
            {t('white_label')}
          </p>
          <p className={styles.iconText}>
            {t('integration')}
            <br />
            {t('make_coinrabbit_yours')}
          </p>
        </div>
        <div>
          <img src={IconHeadphones} alt="IconHeadphones" width={112} height={112} />
          <p className={styles.iconHeading}>
            {t('any_assistance')}
            <br /> {t('of_assistance')}
          </p>
          <p className={styles.iconText}>
            {t('design_dev_marketing')}
            <br />
            {t('say_the_word')}
          </p>
        </div>
        <div>
          <img src={IconCoins} alt="IconCoins" width={112} height={112} />
          <p className={styles.iconHeading}>
            {t('additional_income')}
            <br />
            {t('off_exchanges')}
          </p>
          <p className={styles.iconText}>
            {t('clients_convert')}
            <br />
            {t('loan_into_asset')}
          </p>
        </div>
      </div>
    </div>
  )
}
